// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1Zldm","label":"Radio_label__39q1B","checkMark":"Radio_checkMark__1cr_Y","disabled":"Radio_disabled__11OSR"};